import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
// import Product from './pages/Product'; // Technology page hidden but not deleted
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        {/* <Route path="/product" element={<Product />} /> Technology page hidden but not deleted */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
